$(function () {
  $(window).scroll(function () {
    const wHeight = $(window).height();
    const scrollAmount = $(window).scrollTop();
    const buffer = 300;
    $('.js-fadein').each(function () {
      const targetPosition = $(this).offset().top;
      if (scrollAmount > targetPosition - wHeight + buffer) {
        $(this).find('.about-us-content-image').addClass("is-fadein");
        setTimeout(() => {
          $(this).find('.about-us-content-text').addClass("is-fadein");
        }, 500);
      }
    });
  });
});
